module.exports = __webpack_public_path__ + "img/whatsapp.90e230f7.svg";